import { render, staticRenderFns } from "./doc_svk.vue?vue&type=template&id=7796fa38&scoped=true&"
import script from "./doc_svk.vue?vue&type=script&lang=js&"
export * from "./doc_svk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796fa38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7796fa38')) {
      api.createRecord('7796fa38', component.options)
    } else {
      api.reload('7796fa38', component.options)
    }
    module.hot.accept("./doc_svk.vue?vue&type=template&id=7796fa38&scoped=true&", function () {
      api.rerender('7796fa38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/declaration/item/tabs/doc_svk.vue"
export default component.exports